import React from 'react';
import { motion } from 'framer-motion';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4
      }
    }
  };

  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold text-white mb-4">Categories</h3>
      
      {/* Desktop Filter - Horizontal Pills */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        className="hidden md:flex flex-wrap gap-3"
      >
        {categories.map((category) => (
          <motion.button
            key={category.id}
            variants={itemVariants}
            onClick={() => onCategoryChange(category.id)}
            className={`px-6 py-3 rounded-full font-medium transition-all duration-300 border ${
              selectedCategory === category.id
                ? 'bg-gradient-to-r from-accent-500 to-accent-600 text-white border-accent-500 shadow-lg scale-105'
                : 'bg-dark-800/50 text-dark-300 border-dark-600 hover:bg-dark-700/50 hover:text-white hover:border-dark-500'
            }`}
            whileHover={{ scale: selectedCategory === category.id ? 1.05 : 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="flex items-center space-x-2">
              <span>{category.name}</span>
              <span className={`text-xs px-2 py-0.5 rounded-full ${
                selectedCategory === category.id
                  ? 'bg-white/20 text-white'
                  : 'bg-dark-600 text-dark-400'
              }`}>
                {category.count}
              </span>
            </span>
          </motion.button>
        ))}
      </motion.div>

      {/* Mobile Filter - Dropdown */}
      <div className="md:hidden">
        <select
          value={selectedCategory}
          onChange={(e) => onCategoryChange(e.target.value)}
          className="w-full bg-dark-800 border border-dark-600 text-white px-4 py-3 rounded-lg focus:border-accent-500 focus:outline-none appearance-none cursor-pointer"
        >
          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name} ({category.count})
            </option>
          ))}
        </select>
      </div>

      {/* Category Description */}
      {selectedCategory && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="mt-4"
        >
          <p className="text-dark-400 text-sm">
            {categories.find(cat => cat.id === selectedCategory)?.description}
          </p>
        </motion.div>
      )}
    </div>
  );
};

export default CategoryFilter;